export enum AdjustParkerRegistrationEvaluatedFunctionType {
  AdjustStartTime = 'AdjustStartTime',
  AdjustEndTime = 'AdjustEndTime'
}
